import React from 'react'
import ReactMarkdown from 'react-markdown'
import SpinnerLoading from '@components/V3/loadingIndicators/Spinner'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'
import {useTranslation} from 'next-i18next'

export default function FullyBlocked({redirectUrl}: {redirectUrl?: string}) {
  const {t} = useTranslation('checkoutv3', {keyPrefix: 'payTransition'})
  const isDarkMode = useIsDarkMode()

  return (
    <div
      className={classnames({
        'fixed h-full w-full z-20 items-center justify-center flex flex-col space-y-4 ': true,
        'bg-white/95 text-gray-700': !isDarkMode,
        'bg-black/95 text-white': isDarkMode
      })}>
      <SpinnerLoading size="xl" color={isDarkMode ? 'white' : 'gray'} />
      <div className="text-sm px-2 text-center">
        <ReactMarkdown>{t('transitionMessage')}</ReactMarkdown>
      </div>
      <p className="text-xs">{t('transitionDelay')}</p>
      <p
        className={classnames({
          'text-sm transition-opacity ease-in-out duration-400 text-center': true,
          'opacity-0': !redirectUrl,
          'opacity-100': !!redirectUrl
        })}>
        <span>{t('manualRedirect')}</span>
        <br />
        <a href={redirectUrl}>{redirectUrl}</a>
      </p>
    </div>
  )
}
